import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import {
  Box, Grid, TextField, FormHelperText, FormControl,
  InputAdornment,
  IconButton,
  ClickAwayListener,
} from '@material-ui/core';
import RemoveIcon from '@material-ui/icons/Remove';
import { DateRangePicker } from '@material-ui/pickers';
import { dateShortFormat } from 'shared/constants/dateFormats';
import { Clear } from '@material-ui/icons';

const RangeDatePicker = ({
  onChange, value, error, setOpen, open, allowedDates, minDate, maxDate, onBlur, disabled,
}) => {
  const dateInArray = (date, array) => array.some(d => +d === +date);
  const startDateRef = useRef(null);

  const disableDates = date => {
    if (allowedDates.length > 0) {
      return (!dateInArray(date, allowedDates));
    }
    return false;
  };

  const toggleDateRangePicker = () => {
    setOpen(!open);
  };

  const toggleDateRangePickerEnd = () => {
    if (startDateRef.current) {
      startDateRef.current.click();
    }
  };

  return (
    <FormControl error={Boolean(error?.message)} fullWidth>
      <ClickAwayListener
        onClickAway={ev => {
          if (ev.target.closest('.MuiPickersPopper-root')) return;
          setOpen(false);
        }}
      >
        <DateRangePicker
          minDate={minDate}
          maxDate={maxDate}
          open={open}
          inputFormat={dateShortFormat}
          value={value || [null, null]}
          onChange={newValue => {
            onChange(newValue);
          }}
          shouldDisableDate={disableDates}
          onClose={() => {}}
          closeOnSelect
          defaultRangePosition="start"
          renderInput={(startProps, endProps) => (
            <Grid container spacing={1} alignItems="center">
              <Grid item xs>
                <TextField
                  inputRef={startDateRef}
                  onClick={toggleDateRangePicker}
                  {...startProps}
                  helperText=""
                  label="Start Date"
                  variant="filled"
                  error={Boolean(error?.message)}
                  fullWidth
                  required
                  onBlur={onBlur}
                  disabled={disabled}
                  InputProps={
                    {
                      endAdornment:
                      (
                        <InputAdornment position="end">
                          <IconButton onClick={() => onChange([null, null])}>
                            <Clear />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }
                  }
                />
              </Grid>
              <Grid item>
                <RemoveIcon />
              </Grid>
              <Grid item xs>
                <TextField
                  onClick={toggleDateRangePickerEnd}
                  {...endProps}
                  helperText=""
                  label="End Date"
                  variant="filled"
                  error={Boolean(error?.message)}
                  fullWidth
                  required
                  disabled={disabled}
                  InputProps={
                    {
                      endAdornment:
                      (
                        <InputAdornment position="end">
                          <IconButton onClick={() => onChange([null, null])}>
                            <Clear />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <Box marginLeft="14px">
                  <FormHelperText>{error.message}</FormHelperText>
                </Box>
              </Grid>
            </Grid>
          )}
        />
      </ClickAwayListener>
    </FormControl>
  );
};

RangeDatePicker.defaultProps = {
  setOpen: () => {},
  error: {},
  allowedDates: [],
  minDate: null,
  maxDate: null,
  onBlur: () => {},
  disabled: false,
};

RangeDatePicker.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
  error: PropTypes.shape({
    message: PropTypes.string,
    type: PropTypes.string,
  }),
  allowedDates: PropTypes.arrayOf(PropTypes.object),
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
};

export default RangeDatePicker;
